<template>
  <v-card light flat :color="mine ? 'white' : '#fff3d6'">
    <v-card-title primary-title>
      <b>
        <span v-if="mine">Вы</span>
        <span v-else>Оператор поддержки #{{message.operatorid}}</span>
      </b>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span class="grey--text text--darken-2">{{time}}</span>
    </v-card-title>
    <v-card-text>
      <p v-if="message.operatorid" v-html="messageHtml"></p>
      <p v-else>{{ message.content }}</p>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ChatMessage',
  props: [
    'message'
  ],
  computed: {
    mine () {
      return this.message.operatorid === null
    },
    time () {
      return moment(this.message.cts).fromNow()
    },
    messageHtml () {
      if (!this.message || !this.message.operatorid) return
      return this.message.content.replace(/((http|https):\/\/[.\w/=\-_&?]+)/gi, "<a href='$1' target=\"_blank\">$1</a>")
    }
  }
}
</script>

<style>
</style>
